import dayjs from "dayjs";
import { ITableElement } from "shared/components";
import { columnsUsersType } from "../types/columsUsers.types";

export const columnsGridUsers = (): ITableElement<columnsUsersType>[] => {
  const columnsTable = [
    {
      field: "organizationCode",
      headerName: "Código Prestador",
      sortable: "organizationCode",
      minWidth: 160,
      renderCell(params: columnsUsersType) {
        return <>{params.organizationCode ?? ""}</>;
      },
    },
    {
      field: "employerIdNumber",
      headerName: "Nit Contratista",
      sortable: "employerIdNumber",
      minWidth: 140,
      renderCell(params: columnsUsersType) {
        return <>{params.employerIdNumber ?? ""}</>;
      },
    },
    {
      field: "natureIdentification",
      headerName: "Naturaleza",
      sortable: "natureIdentification",
      minWidth: 140,
      renderCell(params: columnsUsersType) {
        return <>{params.natureIdentification?.name ?? ""}</>;
      },
    },
    {
      field: "givenName",
      headerName: "Razón social",
      minWidth: 300,
      sortable: "givenName",
      renderCell(params: columnsUsersType) {
        return <>{params.givenName ?? ""}</>;
      },
    },
    {
      field: "acreedor",
      headerName: "Acreedor",
      minWidth: 200,
      sortable: "acreedor",
      renderCell(params: columnsUsersType) {
        return <>{params.acreedor ?? ""}</>;
      },
    },
    {
      field: "region",
      headerName: "Departamento",
      minWidth: 200,
      renderCell(params: columnsUsersType) {
        return <>{params.region.name ?? ""}</>;
      },
    },
    {
      field: "locality",
      headerName: "Municipio",
      minWidth: 200,
      renderCell(params: columnsUsersType) {
        return <>{params.locality.name ?? ""}</>;
      },
    },
    {
      field: "streetAddress",
      headerName: "Dirección",
      minWidth: 300,
      renderCell(params: columnsUsersType) {
        return <>{params.streetAddress ?? ""}</>;
      },
    },
    {
      field: "email",
      headerName: "Email 1",
      minWidth: 200,
      renderCell(params: columnsUsersType) {
        return <>{params.email ?? ""}</>;
      },
    },
    {
      field: "emailTwo",
      headerName: "Email 2",
      minWidth: 200,
      renderCell(params: columnsUsersType) {
        return <>{params.emailTwo ?? ""}</>;
      },
    },
    {
      field: "phoneNumberOne",
      headerName: "Teléfono 1",
      minWidth: 140,
      renderCell(params: columnsUsersType) {
        return <>{params.phoneNumberOne ?? ""}</>;
      },
    },
    {
      field: "phoneNumberTwo",
      headerName: "Teléfono 2",
      minWidth: 140,
      renderCell(params: columnsUsersType) {
        return <>{params.phoneNumberTwo ?? ""}</>;
      },
    },
    {
      field: "contactPersonOne",
      headerName: "Contacto 1",
      minWidth: 200,
      renderCell(params: columnsUsersType) {
        return <>{params.contactPersonOne ?? ""}</>;
      },
    },
    {
      field: "contactPersonTwo",
      headerName: "Contacto 2",
      minWidth: 200,
      renderCell(params: columnsUsersType) {
        return <>{params.contactPersonTwo ?? ""}</>;
      },
    },
    {
      field: "contactPersonOccupationOne",
      headerName: "Cargo Contacto",
      minWidth: 200,
      renderCell(params: columnsUsersType) {
        return <>{params.contactPersonOccupationOne ?? ""}</>;
      },
    },
    {
      field: "contactPersonOccupationTwo",
      headerName: "Cargo Contacto 2",
      minWidth: 200,
      renderCell(params: columnsUsersType) {
        return <>{params.contactPersonOccupationTwo ?? ""}</>;
      },
    },
  ];
  return columnsTable;
};
